class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

    // FacetFiltersForm.rerenderSubCategories();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop"
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    console.log("renderProductGridContainer");
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    const categoryEl = document.querySelector(
      "#FacetFiltersForm .facets__disclosure-vertical[data-label='Category']"
    );
    const categoryElChecked = categoryEl.querySelector(
      "ul.no-js-hidden [name='filter.p.m.custom.category']:checked"
    ).value;

    const subCategoryEL = document.querySelector(
      "#FacetFiltersForm .facets__disclosure-vertical[data-label='Subcategory']"
    );

    const productTypeEL = document.querySelector(
      "#FacetFiltersForm .facets__disclosure-vertical[data-label='Product type']"
    );

    if (!categoryElChecked) {
      subCategoryEL.classList.add("hide");
      productTypeEL.classList.add("hide");
    } else {
      if (subCategoryEL) {
        subCategoryEL.classList.remove("hide");

        const subCategoryChildElements = subCategoryEL
          .querySelector("ul.no-js-hidden")
          .querySelectorAll(".list-menu__item");

        const subCatAllChildrenHidden = Array.from(
          subCategoryChildElements
        ).every((child) => {
          return child.offsetHeight === 0 && child.offsetWidth === 0;
        });

        const subCategoryElChecked = subCategoryEL.querySelector(
          "ul.no-js-hidden [name='filter.p.m.sub.category']:checked"
        );

        if (subCategoryElChecked.value) {
          productTypeEL.classList.remove("hide");
        } else {
          productTypeEL.classList.add("hide");
        }

        if (subCatAllChildrenHidden) {
          console.log("All Hidden");
          subCategoryEL.classList.add("hide");
          productTypeEL.classList.remove("hide");
        } else {
          console.log("Not All Hidden");
          subCategoryEL.classList.remove("hide");
          // productTypeEL.classList.add("hide");
        }
      } else {
        productTypeEL.classList.remove("hide");
      }
    }

    const productTypeELChecked = productTypeEL.querySelector(
      "ul.no-js-hidden [name='filter.p.product_type']:checked"
    );

    if (productTypeELChecked) {
      productTypeEL.classList.remove("hide");
    }

    // if (
    //   document.querySelector(
    //     "#FacetFiltersForm .facets__disclosure-vertical[data-label='Category'] [name='filter.p.m.custom.category']:checked"
    //   )
    // ) {
    //   console.log(
    //     document.querySelector(
    //       "#FacetFiltersForm .facets__disclosure-vertical[data-label='Category'] [name='filter.p.m.custom.category']:checked"
    //     )
    //   );
    //   document
    //     .querySelector(
    //       "#FacetFiltersForm .facets__disclosure-vertical[data-label='Product type']"
    //     )
    //     .classList.remove("hide");
    // } else {
    //   document
    //     .querySelector(
    //       "#FacetFiltersForm .facets__disclosure-vertical[data-label='Product type']"
    //     )
    //     .classList.add("hide");
    // }

    var endlessScroll = new Ajaxinate({
      container: "#product-grid",
      pagination: "#Huratips-Pagination",
      callback: facetsAjaxinateCallBack,
    });

    facetsAjaxinateCallBack();

    function facetsAjaxinateCallBack() {
      frcp && frcp.wishlist && frcp.wishlist.attachOnCollection();
      const ssSvgContent = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#111111" viewBox="0 0 256 256">
          <path class="inactive" d="M178,32c-20.65,0-38.73,8.88-50,23.89C116.73,40.88,98.65,32,78,32A62.07,62.07,0,0,0,16,94c0,70,103.79,126.66,108.21,129a8,8,0,0,0,7.58,0C136.21,220.66,240,164,240,94A62.07,62.07,0,0,0,178,32ZM128,206.8C109.74,196.16,32,147.69,32,94A46.06,46.06,0,0,1,78,48c19.45,0,35.78,10.36,42.6,27a8,8,0,0,0,14.8,0c6.82-16.67,23.15-27,42.6-27a46.06,46.06,0,0,1,46,46C224,147.61,146.24,196.15,128,206.8Z"></path>
          <path class="active" d="M240,94c0,70-103.79,126.66-108.21,129a8,8,0,0,1-7.58,0C119.79,220.66,16,164,16,94A62.07,62.07,0,0,1,78,32c20.65,0,38.73,8.88,50,23.89C139.27,40.88,157.35,32,178,32A62.07,62.07,0,0,1,240,94Z"></path>
        </svg>
      `;

      var wicon = document
        .querySelectorAll(".frcp-wishlist-btn__icon")
        .forEach(function (el) {
          el.innerHTML = ssSvgContent;
          el.style.opacity = 1;
        });
    }

    const ssFiltersCount = $(
      "#FacetFiltersForm .facets__selected:not(.hidden)"
    );
    let ssTotalCount = 0;
    if (ssFiltersCount.length) {
      $.each(ssFiltersCount, function (indexInArray, valueOfElement) {
        ssTotalCount += parseInt($(this).text().replace(/[()]/g, ""));
      });
    }

    const catChildCount = $(
      '#FacetFiltersForm details[data-label="Category"] fieldset ul.no-js-hidden'
    ).children().length;
    if (catChildCount && catChildCount == 1) --ssTotalCount;

    const subCatChildCount = $(
      '#FacetFiltersForm details[data-label="Subcategory"] fieldset ul.no-js-hidden'
    ).children().length;
    if (subCatChildCount && subCatChildCount == 1) --ssTotalCount;

    if (ssTotalCount > 0) {
      $(".ss-filter-count").text(ssTotalCount);
      $(".ss-filter-count").removeClass("hidden");
      $(".ss-active-facets-mobile").removeClass("hidden");
      $("#FacetSortForm").addClass("ss-active-filters");
      $(".ss-active-facets-check").addClass("active");
    } else {
      $(".ss-filter-count").text("0");
      $(".ss-filter-count").addClass("hidden");
      $(".ss-active-facets-mobile").addClass("hidden");
      $("#FacetSortForm").removeClass("ss-active-filters");
      $(".ss-active-facets-check").removeClass("active");
    }

    // FacetFiltersForm.ssWishlistInit().then(function () {
    //   if (document.querySelector(".frcp-wishlist-btn__icon") != null) {
    //     document
    //       .querySelectorAll(".frcp-wishlist-btn__icon")
    //       .forEach(function (el) {
    //         el.innerHTML = `
    //           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#111111" viewBox="0 0 256 256">
    //             <path class="inactive" d="M178,32c-20.65,0-38.73,8.88-50,23.89C116.73,40.88,98.65,32,78,32A62.07,62.07,0,0,0,16,94c0,70,103.79,126.66,108.21,129a8,8,0,0,0,7.58,0C136.21,220.66,240,164,240,94A62.07,62.07,0,0,0,178,32ZM128,206.8C109.74,196.16,32,147.69,32,94A46.06,46.06,0,0,1,78,48c19.45,0,35.78,10.36,42.6,27a8,8,0,0,0,14.8,0c6.82-16.67,23.15-27,42.6-27a46.06,46.06,0,0,1,46,46C224,147.61,146.24,196.15,128,206.8Z"></path>
    //             <path class="active" d="M240,94c0,70-103.79,126.66-108.21,129a8,8,0,0,1-7.58,0C119.79,220.66,16,164,16,94A62.07,62.07,0,0,1,78,32c20.65,0,38.73,8.88,50,23.89C139.27,40.88,157.35,32,178,32A62.07,62.07,0,0,1,240,94Z"></path>
    //           </svg>
    //         `;
    //         el.style.opacity = 1;
    //       });
    //   }
    // });
  }

  // static ssWishlistInit() {
  //   return new Promise(function (resolve, reject) {
  //     frcp.wishlist.initialize();
  //     resolve();
  //   });
  // }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    console.log("renderFilters");

    window.scrollTo({ top: 0, behavior: "smooth" });
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      ).innerHTML = element.innerHTML;
    });

    // FacetFiltersForm.rerenderSubCategories();

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter")
      );
  }

  static rerenderSubCategories() {
    const categoryParam = FacetFiltersForm.getParameterValue(
      FacetFiltersForm.searchParamsPrev,
      "filter.p.m.custom.category"
    );
    const subcategoryParam = FacetFiltersForm.getParameterValue(
      FacetFiltersForm.searchParamsPrev,
      "filter.p.m.sub.category"
    );

    if (subcategoryParam && categoryParam) {
      const section_id = document.getElementById("product-grid").dataset.id;
      const ssSearchParams = `filter.p.m.custom.category=${categoryParam}&filter.p.m.sub.category=${subcategoryParam}`;

      const url = `${window.location.pathname}?section_id=${section_id}&${ssSearchParams}`;

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          const ssParsedHTML = new DOMParser().parseFromString(
            html,
            "text/html"
          );
          const ssFacetDetailsElements = ssParsedHTML.querySelector(
            "#FacetFiltersForm .js-filter[data-label='Subcategory']"
          );
          console.log(ssFacetDetailsElements);

          document.querySelector(
            "#FacetFiltersForm .js-filter[data-label='Subcategory']"
          ).innerHTML = ssFacetDetailsElements.innerHTML;

          console.log(
            document
              .querySelector(
                "#FacetFiltersForm .js-filter[data-label='Subcategory']"
              )
              .querySelector(
                `input[value="${decodeURIComponent(subcategoryParam)}"]`
              )
          );

          console.log(subcategoryParam);
          console.log(FacetFiltersForm.searchParamsPrev);

          document
            .querySelector(
              "#FacetFiltersForm .js-filter[data-label='Subcategory']"
            )
            .querySelector(
              `input[value="${decodeURIComponent(subcategoryParam)}"]`
            ).checked = true;
        });
    }
  }

  static getParameterValue(parameterString, paramName) {
    // Split the parameterString into an array of parameter key-value pairs
    const params = parameterString.split("&");

    // Loop through the key-value pairs and find the one with the specified parameter name
    for (const param of params) {
      const [key, value] = param.split("=");
      if (key === paramName) {
        return decodeURIComponent(value); // Use decodeURIComponent to handle URL-encoded values
      }
    }

    // Return null if the parameter is not found
    return null;
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".ss-active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    console.log(1, searchParams);
    var newParams = "";
    var sortByVal = $("#SortBy").val();
    if (sortByVal != "") {
      newParams = "sort_by=" + sortByVal;
    } else {
      newParams = "sort_by=";
    }
    $("#FacetsWrapperDesktop > .js-filter").each(function () {
      $(this)
        .find(
          ".no-js-hidden input[type='checkbox'], .no-js-hidden input[type='radio'][id^='Filter-Category-'], .no-js-hidden input[type='radio'][id^='Filter-Subcategory-']"
        )
        .each(function () {
          if (!$(this).parents("details.js-filter").is(":visible")) return;
          if ($(this).is(":checked")) {
            newParams +=
              "&" +
              $(this).attr("name") +
              "=" +
              encodeURIComponent($(this).val());
          }
        });
    });

    var searchParams_arr = searchParams.split("&");
    for (var i = 0; i < searchParams_arr.length; i++) {
      if (searchParams_arr[i].includes("q=")) {
        newParams += "&" + searchParams_arr[i];
      }
    }
    //console.log(2, newParams);
    FacetFiltersForm.renderPage(newParams, event);
    //FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (
      event.target.tagName.toLowerCase() === "input" &&
      event.target.type === "search"
    ) {
      console.log("Search");
      return;
    }
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form"
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form")
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile =
        event.target.closest("form").id === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm"
          ) {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    console.log("onActiveFilterClick");
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
